import React from 'react';
import { Suspense } from 'react';
import { formatDate } from 'utilities/common';
import _ from 'underscore';
import { useDispatch } from 'react-redux';
import { Track } from 'services/action';
import Zoom from 'react-medium-image-zoom';

const Maps = React.lazy(() => import('ui/components/maps/mapbox'));

const List = ({ log, content }) => {
  return (
    <li className="pb-4">
      <div className="log-timestamp">
        <div className="d-flex justify-content-between">
          <div>{formatDate(log, 'HH:mm')}</div>
        </div>
      </div>
      <div className="text-muted" style={{ wordWrap: 'break-word' }}>
        {content}
      </div>
    </li>
  );
};

const TableRow = ({ data, keys }) => {
  const Dispatch = useDispatch();

  const [expanded, setExpanded] = React.useState(false);
  const [logs, setLogs] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [images, setImages] = React.useState(null);

  const toggleExpander = async (e) => {
    setExpanded(!expanded);
  };

  const $convertLogs = async () => {
    let newLog = [];
    let newData = null;

    _.each(data?.logs, function (log) {
      const payload = {
        ...log,
        recorded_at_filter: formatDate(log?.recorded_at, 'YYYY-MM-DD'),
      };

      newLog.push(payload);
    });

    if (newLog?.length > 0) {
      newData = _.groupBy(newLog, function (log) {
        return log?.recorded_at_filter;
      });
    }

    setLogs(newData);
  };

  const $getImage = async (e) => {
    const req = await Dispatch(Track.$getImage(e));

    if (req?.message === 'success') {
      setImages(req?.data);
    }
  };

  React.useEffect(() => {
    if (expanded) {
      $convertLogs();
      $getImage(data?.id);
    }
  }, [expanded]);

  React.useEffect(() => {
    if (!data) return;

    const firstLog = data?.logs[0];
    let status = 'process';
    if (firstLog?.action === 'new' || firstLog?.action === 'delivered' || firstLog?.action === "returned") {
      status = firstLog?.action;
    }

    setStatus(status);

    if (keys === 0) {
      setExpanded(true);
    }
  }, [data]);

  return [
    <tr className="cursor-pointer bg-white" onClick={toggleExpander} key={keys}>
      <td
        style={{
          whiteSpace: 'initial',
          width: '5%',
          paddingTop: 25,
          paddingBottom: 25,
        }}
        className="px-2"
      >
        {keys + 1}
      </td>
      <td
        style={{
          whiteSpace: 'initial',
          width: '20%',
          paddingTop: 25,
          paddingBottom: 25,
        }}
      >
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {data?.code}
          </div>
          {data?.ref_code && (
            <small className="info">REF: {data?.ref_code}</small>
          )}
        </div>
      </td>
      <td
        style={{
          whiteSpace: 'initial',
          width: '30%',
          paddingTop: 25,
          paddingBottom: 25,
        }}
      >
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {data?.destination?.region?.regency_name},{' '}
            {data?.destination?.region?.province_name}
          </div>
        </div>
      </td>
      <td
        style={{
          whiteSpace: 'initial',
          width: '15%',
          paddingTop: 25,
          paddingBottom: 25,
        }}
      >
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {formatDate(data?.ata_at, 'DD MMM YYYY')}
          </div>
        </div>
      </td>
      <td
        style={{
          whiteSpace: 'initial',
          width: '15%',
          paddingTop: 25,
          paddingBottom: 25,
        }}
      >
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {data?.received_by || '-'}
          </div>
        </div>
      </td>
      <td
        style={{
          whiteSpace: 'initial',
          width: '15%',
          paddingTop: 25,
          paddingBottom: 25,
        }}
      >
        <div className="table-col">
          <span className={`badge status-${status}-lt ms-auto`}>{status}</span>
        </div>
      </td>
    </tr>,
    expanded && (
      <tr className="bg-light" key={`expanded-${keys}`}>
        <td colSpan={6}>
          <div className="mt-3">
            <Suspense fallback={<div>Loading...</div>}>
              <Maps log={data?.logs} />
            </Suspense>
          </div>
          <div className="row mt-3">
            <div className="col-md-6 mb-3 mb-md-0 ">
              <div className="border rounded-3 bg-white p-3 ">
                <div className="fs-7 text-primary mb-3">
                  Kode Tracking:{' '}
                  <span className="text-secondary fw-bold">
                    {data?.tracking_code ? data?.tracking_code : data?.code}
                  </span>
                </div>
                <div className="row pb-4">
                  {/* <div className="col">
                    <div>
                      <div className="page-pretitle text-primary mb-1">
                        Estimasi sampai
                      </div>
                      <div className="title">{formatDate(data?.eta_at)}</div>
                    </div>
                  </div> */}
                  {data?.origin && (
                    <div className="col">
                      <div>
                        <div className="page-pretitle text-primary mb-1">
                          Asal
                        </div>
                        <div className="title">
                          {' '}
                          {data?.origin?.region?.regency_name},{' '}
                          {data?.origin?.region?.province_name}
                        </div>
                      </div>
                    </div>
                  )}
                  {data?.destination && (
                    <div className="col">
                      <div>
                        <div className="page-pretitle text-primary mb-1">
                          Tujuan
                        </div>
                        <div className="title">
                          {data?.destination?.region?.regency_name},{' '}
                          {data?.destination?.region?.province_name}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="row pb-4 border-bottom">
                  {data?.origin && (
                    <div className="col">
                      <div>
                        <div className="page-pretitle text-primary mb-1">
                          Pengirim
                        </div>
                        <div className="title">{data?.shipper?.name}</div>
                      </div>
                    </div>
                  )}
                  {data?.destination && (
                    <div className="col">
                      <div>
                        <div className="page-pretitle text-primary mb-1">
                          Penerima
                        </div>
                        <div className="title">{data?.received_by || data?.destination?.name}</div>
                      </div>
                    </div>
                  )}
                </div>

                {images?.length > 0 ? (
                  <div className="d-flex flex-wrap gap-2 justify-content-center align-items-center pt-3">
                    {images?.map((d, i) => (
                      <div key={i}>
                        <Zoom>
                          <div
                            style={{
                              width: 60,
                              height: 60,
                              backgroundColor: '#fff',
                              backgroundImage: `url(${d?.image.replace(
                                '_thumb',
                                ''
                              )})`,
                              backgroundSize: 'contain',
                              backgroundPosition: 'center center',
                              backgroundRepeat: 'no-repeat',
                            }}
                          />
                        </Zoom>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="col-md-6 ">
              <div className="log-container border rounded-3  p-3 h-100 bg-white">
                <div className="fs-7 text-primary mb-3">Log</div>

                <div
                  style={{
                    maxHeight: 500,
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    paddingTop: 10,
                    paddingBottom: 10,
                  }}
                >
                  {logs &&
                    Object.entries(logs)?.map(([key, value]) => (
                      <div className="row" key={key}>
                        <div className="col-4">
                          <div className="fs-8">
                            {formatDate(new Date(key), 'dddd,')}
                          </div>
                          <div className="fs-8 fw-bold">
                            {formatDate(new Date(key), 'DD MMMM YYYY')}
                          </div>
                        </div>
                        <div className="col-8">
                          <div className="log-timeline-new">
                            <ul className="log-new">
                              {value?.map((l, i) => (
                                <List
                                  key={i}
                                  content={l?.message}
                                  log={l?.recorded_at}
                                />
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    ),
  ];
};

export default TableRow;
